import { Text, Image } from '@lounge-fe/ui-kit'
import { Money } from '@shopify/hydrogen-react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { UpsellsItemProps } from './types'
import { ProductForm } from '../ProductForm'
import { useShopify } from '@/hooks/useShopify'
import { Price } from '../Price'

export const Item = ({
  id,
  title,
  color,
  image,
  price,
  compareAtPrice,
  secondaryImage,
  options,
  handle,
  variants,
  linkedBottoms,
  hide_out_of_stock_form: hideOutOfStockForm,
  onSuccess,
}: UpsellsItemProps): JSX.Element => {
  const url = `/products/${handle}`

  return (
    <div className="flex flex-col border-b border-primary-default last:border-b-0 pb-6 gap-3 sm:gap-4">
      <div className="flex flex-col gap-1">
        <Text variant="title-five">
          <a href={url}>
            {title} - <span className="text-[#888888]">{color}</span>
          </a>
        </Text>
        <Price
          price={price / 100}
          compareAtPrice={compareAtPrice ? compareAtPrice / 100 : null}
        />
      </div>
      <a className="flex gap-1" href={url}>
        {image && (
          <div className="bg-surface-primary-default aspect-square block w-full">
            <Image
              {...image}
              className={classNames(
                'object-cover w-full h-full aspect-[1/1]',
                image.className,
              )}
            />
          </div>
        )}
        {secondaryImage && (
          <div className="bg-surface-primary-default aspect-square block w-full">
            <Image
              {...secondaryImage}
              className={classNames(
                'object-cover w-full h-full aspect-[1/1]',
                secondaryImage.className,
              )}
            />
          </div>
        )}
      </a>
      <ProductForm
        product={
          {
            id,
            title,
            color,
            image,
            price,
            compareAtPrice,
            handle,
          } as UpsellsItemProps
        }
        onSuccess={onSuccess}
        hasOnlyDefaultVariant={false}
        options={options}
        variants={variants}
        linked_bottoms={linkedBottoms}
      />
    </div>
  )
}
